import {useEffect, useState} from 'react';

export const useUploadPreview = () => {
  const [previews, setPreviews] = useState<{id: string; uri: string}[]>([]);

  const createPreview = (file: File) => {
    const preview = URL.createObjectURL(file);
    setPreviews((prevPreviews) => [...prevPreviews, {id: file.name, uri: preview}]);
  };

  const removePreview = (file: File) => {
    setPreviews((prevPreviews) => {
      const preview = prevPreviews.find((p) => p.id === file.name);
      if (preview) {
        URL.revokeObjectURL(preview.uri);
      }
      return prevPreviews.filter((preview) => preview.id !== file.name);
    });
  };

  const clearPreviews = () => {
    setPreviews([]);
  };

  // Revoke object URLs when component unmounts
  useEffect(() => {
    const previewsRef = previews;
    return () => {
      previewsRef.forEach((preview) => URL.revokeObjectURL(preview.uri));
    };
  }, [previews]);

  return {
    createPreview,
    removePreview,
    previews,
    clearPreviews,
  };
};
